import { gql } from "../__generated__";

gql(`
    fragment InvitationFields on Invitation {
        id
        phoneNumber
        createdAt
        token
        senderName
        clientName
        clientLogoUrl
        text
        mode
        firstName
        lastName
    }
`);

export const ALL_INVITATIONS = gql(`
    query AllInvitations {
        allInvitations {
            count
            elements {
                ...InvitationFields
            }
        }
    }
`);

export const PENDING_INVITATIONS = gql(`
    query PendingInvitations {
        pendingInvitations {
            count
            elements {
                ...InvitationFields
            }
        }
    }
`);

export const GET_INVITATION = gql(`
    query GetInvitation($invitationId: ID!) {
        getInvitation(invitationId: $invitationId) {
            ...InvitationFields
        }
    }
`);

export const ACCEPT_INVITATION = gql(`
    mutation AcceptInvitation($token: String!) {
        acceptInvitation(token: $token)
    }
`);

export const REJECT_INVITATION = gql(`
    mutation RejectInvitation($token: String!) {
        rejectInvitation(token: $token)
    }
`);

export const CANCEL_INVITATION = gql(`
    mutation CancelInvitation($invitationId: ID!) {
        cancelInvitation(invitationId: $invitationId)
    }
`);

export const SEND_INVITATION = gql(`
    mutation SendInvitation($phoneNumber: String!, $firstName: String, $lastName: String) {
        sendInvitation(phoneNumber: $phoneNumber, firstName: $firstName, lastName: $lastName) {
            __typename
            ... on SendInvitationSuccess {
                newInvitation
            }
            ... on SendInvitationError {
                message
                messageKey
            }
        }
    }
`);
